import { z } from "zod";

import { eventTypeAppCardZod } from "@calcom/app-store/eventTypeAppCardZod";

/**
 * Schéma des credentials marchand Alma.
 *
 * Alma sépare clairement clé sandbox (préfixe `sk_test_`) et clé live (préfixe `sk_live_`) —
 * confirmé par `https://docs.almapay.com/reference/authentification.md` (deux dashboards distincts,
 * `dashboard.sandbox.getalma.eu` vs `dashboard.getalma.eu`). On reprend le pattern `hitpay`
 * (`packages/app-store/hitpay/lib/hitpayCredentialKeysSchema.ts`) : un couple de clés par
 * environnement + un switch `isSandbox`, plutôt qu'une seule clé + un simple booléen — c'est le motif
 * le plus prudent quand deux clés distinctes existent réellement (contrairement à Pledg où c'est resté
 * incertain, cf. `specs/payment-pledg-sofinco/design.md` §2.1).
 */
export const almaCredentialKeysSchema = z.object({
  prod: z
    .object({
      apiKey: z.string(),
    })
    .optional(),
  sandbox: z
    .object({
      apiKey: z.string(),
    })
    .optional(),
  isSandbox: z.boolean(),
});

export const AlmaPaymentOptions = [
  {
    label: "on_booking_option",
    value: "ON_BOOKING",
  },
  // Pas de HOLD : Alma ne propose pas de "collecter puis débiter plus tard" façon no-show fee,
  // cf. packages/app-store/PAYMENT_APP_GUIDE.md:158-160 et design équivalent pour Pledg.
];

type PaymentOption = (typeof AlmaPaymentOptions)[number]["value"];
const VALUES: [PaymentOption, ...PaymentOption[]] = [
  AlmaPaymentOptions[0].value,
  ...AlmaPaymentOptions.slice(1).map((option) => option.value),
];
export const paymentOptionEnum = z.enum(VALUES);

export const appDataSchema = eventTypeAppCardZod.merge(
  z.object({
    price: z.number(),
    currency: z.string(),
    paymentOption: z.string().optional(),
    enabled: z.boolean().optional(),
  })
);
export const appKeysSchema = z.object({});
